module.exports = __webpack_public_path__ + "static/img/eleme.5d98362b.jpg";